import "font-awesome/css/font-awesome.min.css";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import { Icon } from "semantic-ui-react";
import { loginCookieName } from "./App";
import DropGltfBackup from "./component/DropGltfZone";
import Materials from "./component/Materials";
import ModelViewerInfo from "./component/ModelViewerInfo";
import ProductInfo from "./component/ProductInfo";
import Tabs from "./component/Tabs";
import { getCookie } from "./Cookie";
import { FormModalPopup, ModalPopup } from "./Modal";
import "./style/index.css";

export default function Editor() {
  const history = useHistory();

  useEffect(() => {
    if (!getCookie(loginCookieName)) {
      let path = window.location.pathname.replace("/", "").toString();
      history.push({
        pathname: "/login",
        state: { productUrl: path ? `/${path}` : "/" },
      });
    }

    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);

  });

  const handleResize = () => {
    const modelViewer = document.getElementById("modelViewer");
    const rateHeight = modelViewer.getBoundingClientRect().width / 1.33;
    modelViewer.style.height = rateHeight + "px";
  };

  const tabData = [
    {
      label: <Icon name="paint brush" />,
      content: <ProductInfo />,
    },

    {
      label: <Icon name="camera" />,
      content: <ModelViewerInfo />,
    },

    /*{
      label: <Icon name="file outline" />,
      content: <ProductFeaturesTab />,
    },*/

    {
      label: <Icon name="edit" />,
      content: <Materials />,
    },
  ];

  let title = "<Sugar-Model-Viewer>";

  return (
    <div className="container">
      <div
        className="editorArea"
        style={{
          display: "flex",
        }}
      >
        <DropGltfBackup style={{ background: "#FFFFFF" }} />

        <div className="editPart" id="editPart">
          <div className="modelViewerHeader">
            <p className="spanHeader">
              <Icon name="cube" />
              {title}{" "}
            </p>
          </div>
          <Tabs tabData={tabData} className="tabs" />
        </div>
      </div>
      <ModalPopup />
      <FormModalPopup />
    </div>
  );
}
